import { render } from "./AppleFooter.vue?vue&type=template&id=a0ea319e&lang=true"
import script from "./AppleFooter.vue?vue&type=script&lang=js"
export * from "./AppleFooter.vue?vue&type=script&lang=js"

import "./AppleFooter.vue?vue&type=style&index=0&id=a0ea319e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__